import { Skeleton } from '@townsquare/griffin-main-header/skeleton';
import Loadable from '@townsquare/loadable';
import { onboardingResource } from '@townsquare/onboarding/resource';
import { SiteHomePageRoute } from '@townsquare/router/route-types';
import { goalRoute } from '@townsquare/routes/goal-view';

import { aggGoalViewResource } from './agg/resources/AggGoalViewResource';
import { aggGoalViewTabResource } from './agg/resources/AggGoalViewTabResource';
import { goalContentAggResource } from './resources/GoalContentAggResource';
import { goalViewHeaderAggResource } from './resources/GoalHeaderAggResource';
import { goalHighlightsTabResource } from './resources/GoalHighlightsTab';
import { goalSidebarAggResource } from './resources/GoalSidebarAggResource';
import { goalViewResource } from './resources/GoalView';
import { goalViewAsideResource } from './resources/GoalViewAside';
import { goalViewHeaderResource } from './resources/GoalViewHeader';

goalRoute.component = Loadable({
	loader: () => import(/* webpackChunkName: "goal-view" */ './components/GoalView'),
	loading: () => null,
});
goalRoute.aside = Loadable({
	loader: () => import(/* webpackChunkName: "goal-view-aside" */ './components/GoalViewAside'),
	loading: () => null,
});
goalRoute.header = Loadable({
	loader: () =>
		import(/* webpackChunkName: "goal-view-header" */ './components/GoalHeaderRefreshed'),
	loading: Skeleton,
});
const aggGoalViewLoadable = Loadable({
	loader: () => import(/* webpackChunkName: "agg-goal-view" */ './agg/components/AggGoalView'),
	loading: Skeleton,
});

goalRoute.resources = [
	goalViewResource,
	goalViewAsideResource,
	goalHighlightsTabResource,
	goalViewHeaderResource,
	goalSidebarAggResource,
	goalViewHeaderAggResource,
	goalContentAggResource,
	onboardingResource,
];
goalRoute.featureGating = {
	gates: ['goal_types_m3_bundled_updates'],
	behavior: {
		type: 'override',
		override: {
			component: aggGoalViewLoadable as SiteHomePageRoute['component'],
			header: undefined,
			aside: undefined,
			resources: [aggGoalViewResource, aggGoalViewTabResource, onboardingResource],
			relayEnvironment: 'agg',
			nav4Layout: 'custom',
		},
	},
};

export const goalViewRoute: SiteHomePageRoute = goalRoute;
